let Calendar = function (model, options, date, categories) {

    // Default Values
    this.Options = {
        Color: '',
        LinkColor: '',
        NavShow: true,
        NavVertical: false,
        NavLocation: '',
        DateTimeShow: true,
        DateTimeFormat: 'mmm, yyyy',
        DatetimeLocation: '',
        EventClick: '',
        EventTargetWholeDay: false,
        DisabledDays: [],
        ModelChange: model,
        IsEventCalendar: false,
        eventsWithAjax: false,
    };

    // Overwriting default values
    for (let key in options) {
        this.Options[key] = typeof options[key] == 'string' ? options[key].toLowerCase() : options[key];
    }

    model ? this.Model = model : this.Model = {};
    categories ? this.Categories = categories : this.Categories = {};

    this.Today = new Date();

    this.Selected = this.Today
    this.Today.Month = this.Today.getMonth();
    this.Today.Year = this.Today.getFullYear();
    if (date) {
        this.Selected = date
    }
    this.Selected.Month = this.Selected.getMonth();
    this.Selected.Year = this.Selected.getFullYear();

    this.Selected.Days = new Date(this.Selected.Year, (this.Selected.Month + 1), 0).getDate();
    this.Selected.FirstDay = new Date(this.Selected.Year, (this.Selected.Month), 0).getDay();
    this.Selected.LastDay = new Date(this.Selected.Year, (this.Selected.Month + 1), 0).getDay();

    this.Prev = new Date(this.Selected.Year, (this.Selected.Month - 1), 1);

    if (this.Selected.Month == 0) {
        this.Prev = new Date(this.Selected.Year - 1, 11, 1);
    }
    this.Prev.Days = new Date(this.Prev.getFullYear(), (this.Prev.getMonth() + 1), 0).getDate();
};

function createCalendar(calendar, element, adjuster) {
    if (typeof adjuster !== 'undefined') {
        let newDate = new Date(calendar.Selected.Year, calendar.Selected.Month + adjuster, 1);
        calendar = new Calendar(calendar.Model, calendar.Options, newDate, categories);
        element.innerHTML = '';
    } else {
        for (let key in calendar.Options) {
            typeof calendar.Options[key] != 'function' && typeof calendar.Options[key] != 'object' && calendar.Options[key] ? element.className += " " + key + "-" + calendar.Options[key] : 0;
        }
    }
    let months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

    function AddSidebar() {
        let sidebar = document.createElement('div');
        sidebar.className += 'cld-sidebar';

        let monthList = document.createElement('ul');
        monthList.className += 'cld-monthList';

        for (let i = 0; i < months.length - 3; i++) {
            let x = document.createElement('li');
            x.className += 'cld-month';
            let n = i - (4 - calendar.Selected.Month);
            // Account for overflowing month values
            if (n < 0) {
                n += 12;
            } else if (n > 11) {
                n -= 12;
            }
            // Add Appropriate Class
            if (i == 0) {
                x.className += ' cld-rwd cld-nav';
                x.addEventListener('click', function () {
                    typeof calendar.Options.ModelChange == 'function' ? calendar.Model = calendar.Options.ModelChange() : calendar.Model = calendar.Options.ModelChange;
                    createCalendar(calendar, element, -1);
                });
                x.innerHTML += '<svg height="15" width="15" viewBox="0 0 100 75" fill="rgba(255,255,255,0.5)"><polyline points="0,75 100,75 50,0"></polyline></svg>';
            } else if (i == months.length - 4) {
                x.className += ' cld-fwd cld-nav';
                x.addEventListener('click', function () {
                    typeof calendar.Options.ModelChange == 'function' ? calendar.Model = calendar.Options.ModelChange() : calendar.Model = calendar.Options.ModelChange;
                    createCalendar(calendar, element, 1);
                });
                x.innerHTML += '<svg height="15" width="15" viewBox="0 0 100 75" fill="rgba(255,255,255,0.5)"><polyline points="0,0 100,0 50,75"></polyline></svg>';
            } else {
                if (i < 4) {
                    x.className += ' cld-pre';
                } else if (i > 4) {
                    x.className += ' cld-post';
                } else {
                    x.className += ' cld-curr';
                }

                //prevent losing let adj value (for whatever reason that is happening)
                (function () {
                    let adj = (i - 4);
                    //x.addEventListener('click', function(){createCalendar(calendar, element, adj);console.log('kk', adj);} );
                    x.addEventListener('click', function () {
                        typeof calendar.Options.ModelChange == 'function' ? calendar.Model = calendar.Options.ModelChange() : calendar.Model = calendar.Options.ModelChange;
                        createCalendar(calendar, element, adj);
                    });
                    x.setAttribute('style', 'opacity:' + (1 - Math.abs(adj) / 4));
                    x.innerHTML += months[n].substr(0, 3);
                }()); // immediate invocation

                if (n == 0) {
                    let y = document.createElement('li');
                    y.className += 'cld-year';
                    if (i < 5) {
                        y.innerHTML += calendar.Selected.Year;
                    } else {
                        y.innerHTML += calendar.Selected.Year + 1;
                    }
                    monthList.appendChild(y);
                }
            }
            monthList.appendChild(x);
        }

        sidebar.appendChild(monthList);
        if (calendar.Options.NavLocation) {
            document.getElementById(calendar.Options.NavLocation).innerHTML = "";
            document.getElementById(calendar.Options.NavLocation).appendChild(sidebar);
        } else {
            element.appendChild(sidebar);
        }
    }

    let mainSection = document.createElement('div');
    mainSection.className += "cld-main";

    function AddDateTime() {

        let datetime = document.createElement('div');
        datetime.className += "cld-datetime";

        let today = document.createElement('div');
        today.className += ' today';
        today.innerHTML = months[calendar.Selected.Month] /*+ ", " + calendar.Selected.Year*/;
        datetime.appendChild(today);

        if (calendar.Options.NavShow && !calendar.Options.NavVertical) {
            let rwd = document.createElement('div');
            rwd.className += " cld-rwd cld-nav";
            rwd.addEventListener('click', function () {
                createCalendar(calendar, element, -1);
            });
            rwd.innerHTML = `<svg width="5" height="8" viewBox="0 0 5 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.879468 4.80898L4.16665 8L5 7.19108L1.71284 3.99995L5 0.80883L4.16665 4.76837e-07L0.879587 3.19104L0.833339 3.14614L0 3.95524L0.0461965 4.00009L0 4.04493L0.833339 4.85376L0.879468 4.80898Z" fill="#00B9F0"/></svg>`;
            datetime.appendChild(rwd);


            let fwd = document.createElement('div');
            fwd.className += " cld-fwd cld-nav";
            fwd.addEventListener('click', function () {
                createCalendar(calendar, element, 1);
            });
            fwd.innerHTML = `<svg width="5" height="8" viewBox="0 0 5 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M4.12053 3.19102L0.83335 0L0 0.808916L3.28716 4.00005L0 7.19117L0.83335 8L4.12041 4.80896L4.16666 4.85386L5 4.04476L4.9538 3.99991L5 3.95507L4.16666 3.14624L4.12053 3.19102Z" fill="#00B9F0"/></svg>`;
            datetime.appendChild(fwd);
        }

        if (calendar.Options.DatetimeLocation) {
            document.getElementById(calendar.Options.DatetimeLocation).innerHTML = "";
            document.getElementById(calendar.Options.DatetimeLocation).appendChild(datetime);
        } else {
            mainSection.appendChild(datetime);
        }
    }

    function AddLabels() {
        let labels = document.createElement('ul');
        labels.className = 'cld-labels';
        let labelsList = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
        for (let i = 0; i < labelsList.length; i++) {
            let label = document.createElement('li');
            label.className += "cld-label";
            label.innerHTML = labelsList[i];
            labels.appendChild(label);
        }
        mainSection.appendChild(labels);
    }

    function AddDays() {
        // Create Number Element
        function DayNumber(n) {
            let number = document.createElement('p');
            number.className += "cld-number";
            number.innerHTML += n;
            return number;
        }

        let days = document.createElement('ul');
        days.className += "cld-days";
        // Previous Month's Days
        for (let i = 0; i < (calendar.Selected.FirstDay); i++) {
            let day = document.createElement('li');
            day.className += "cld-day prevMonth";
            //Disabled Days
            let d = i % 7;
            for (let q = 0; q < calendar.Options.DisabledDays.length; q++) {
                if (d == calendar.Options.DisabledDays[q]) {
                    day.className += " disableDay";
                }
            }

            let number = DayNumber((calendar.Prev.Days - calendar.Selected.FirstDay) + (i + 1));
            day.appendChild(number);

            days.appendChild(day);
        }
        // Current Month's Days
        for (let i = 0; i < calendar.Selected.Days; i++) {
            let day = document.createElement('li');
            day.className += "cld-day currMonth";
            //Disabled Days
            let d = (i + calendar.Selected.FirstDay) % 7;
            for (let q = 0; q < calendar.Options.DisabledDays.length; q++) {
                if (d == calendar.Options.DisabledDays[q]) {
                    day.className += " disableDay";
                }
            }
            let number = DayNumber(i + 1);
            let titleList = document.createElement('div');
            titleList.className = "cld-title-list";
            number.appendChild(titleList);
            // Check Date against Event Dates
            for (let n = 0; n < calendar.Model.length; n++) {
                let evFromDate = calendar.Model[n].FromDate;
                let evToDate = calendar.Model[n].ToDate;
                let toDate = new Date(calendar.Selected.Year, calendar.Selected.Month, (i + 1));

                if (evFromDate.getTime() <= toDate.getTime() && evToDate.getTime() >= toDate.getTime()) {
                    if (!number.classList.contains('eventday')) {
                        number.className += " eventday";
                    }

                    for (let c=0; c < calendar.Categories.length; c++) {
                        if (calendar.Categories[c] === calendar.Model[n].CategoryId &&
                            !number.classList.contains(' category-default-' + c) &&
                            !number.classList.contains(" category-" + calendar.Categories[c])
                        ) {
                            number.className += " category-default-" + c;
                            number.className += " category-" + calendar.Categories[c];
                        }
                    }

                    let title = document.createElement('span');
                    title.className += "cld-title";
                    if (typeof calendar.Model[n].Link == 'function' || calendar.Options.EventClick) {
                        let a = document.createElement('a');
                        a.setAttribute('href', '#');
                        a.innerHTML += calendar.Model[n].Title;
                        if (calendar.Options.EventClick) {
                            let z = calendar.Model[n].Link;
                            if (typeof calendar.Model[n].Link != 'string') {
                                a.addEventListener('click', calendar.Options.EventClick.bind.apply(calendar.Options.EventClick, [null].concat(z)));
                                if (calendar.Options.EventTargetWholeDay) {
                                    day.className += " clickable";
                                    day.addEventListener('click', calendar.Options.EventClick.bind.apply(calendar.Options.EventClick, [null].concat(z)));
                                }
                            } else {
                                a.addEventListener('click', calendar.Options.EventClick.bind(null, z));
                                if (calendar.Options.EventTargetWholeDay) {
                                    day.className += " clickable";
                                    day.addEventListener('click', calendar.Options.EventClick.bind(null, z));
                                }
                            }
                        } else {
                            a.addEventListener('click', calendar.Model[n].Link);
                            if (calendar.Options.EventTargetWholeDay) {
                                day.className += " clickable";
                                day.addEventListener('click', calendar.Model[n].Link);
                            }
                        }
                        title.appendChild(a);
                    } else {
                        title.innerHTML += '<a href="' + calendar.Model[n].Link + '">' + calendar.Model[n].Title + '</a>';
                    }
                    titleList.appendChild(title);
                }

                // Marking the filtered/picked dates
                let eventFromFilter = document.getElementById('event_from');
                let eventToFilter = document.getElementById('event_to');

                if ((eventFromFilter && eventToFilter) &&
                    (eventFromFilter.value !== '' && eventToFilter.value !== '')
                ) {
                    let eventFromParts = eventFromFilter.value.match(/(\d+)/g);
                    let eventToParts = eventToFilter.value.match(/(\d+)/g);

                    if (new Date( eventFromParts[2], eventFromParts[1]-1, eventFromParts[0]).getTime() === toDate.getTime()) {
                        if (!number.classList.contains('picked-start')) {
                            number.className += " picked-start";
                        }
                        if (toDate.getDay() === 0 && !number.classList.contains('picked-end')) {
                            number.className += " picked-end";
                        }
                    }

                    if (new Date( eventFromParts[2], eventFromParts[1]-1, eventFromParts[0]).getTime() < toDate.getTime() &&
                        new Date( eventToParts[2], eventToParts[1]-1, eventToParts[0]).getTime() > toDate.getTime())
                    {
                        switch (toDate.getDay()) {
                            case 1:
                                if (!number.classList.contains('picked-start')) {
                                    number.className += " picked-start";
                                }
                                break;
                            case 0:
                                if (!number.classList.contains('picked-end')) {
                                    number.className += " picked-end";
                                }
                                break;
                            default:
                                if (!number.classList.contains('picked-continue')) {
                                    number.className += " picked-continue";
                                }
                        }
                    }

                    if (new Date( eventToParts[2], eventToParts[1]-1, eventToParts[0]).getTime() === toDate.getTime()) {
                        if (!number.classList.contains('picked-end')) {
                            number.className += " picked-end";
                        }
                        if (toDate.getDay() === 1 && !number.classList.contains('picked-start')) {
                            number.className += " picked-start";
                        }
                    }
                }
            }

            if (titleList.childNodes.length == 0) {
                titleList.remove();
            }

            day.appendChild(number);

            // Extension for the event calendar
            if (calendar.Options.IsEventCalendar) {
                if (new Date(calendar.Selected.Year, calendar.Selected.Month, (i + 1)).getTime() === Date.parse(document.getElementById('event_from').value.split('.').reverse().join('.'))) {
                    day.classList.add('from_selected');
                }
                if (new Date(calendar.Selected.Year, calendar.Selected.Month, (i + 1)).getTime() === Date.parse(document.getElementById('event_to').value.split('.').reverse().join('.'))) {
                    day.classList.add('to_selected');
                }

                number.addEventListener('click', () => {

                    let SDate = new Date(calendar.Selected.Year, calendar.Selected.Month, (i + 1));
                    let selectedDate = ('0' + SDate.getDate()).slice(-2) + '.' + ('0' + (SDate.getMonth() + 1)).slice(-2) + '.' + SDate.getFullYear();

                    if (document.querySelector('#event_from.focus')) {
                        document.querySelector('#event_from.focus').value = selectedDate;
                        while(document.querySelectorAll('#event-datepicker .from_selected').length > 0){
                            document.querySelectorAll('#event-datepicker .from_selected')[0].classList.remove('from_selected');
                        }
                        day.classList.add('from_selected');

                        document.getElementById('event_from').classList.remove('focus');
                        document.getElementById('event_to').classList.add('focus');
                        document.getElementById('event_to').focus();

                        return false;
                    }

                    if (document.querySelector('#event_to.focus') &&
                        SDate.getTime() > Date.parse(document.getElementById('event_from').value.split('.').reverse().join('.'))
                    ) {
                        document.querySelector('#event_to.focus').value = selectedDate;
                        while(document.querySelectorAll('#event-datepicker .to_selected').length > 0){
                            document.querySelectorAll('#event-datepicker .to_selected')[0].classList.remove('to_selected');
                        }
                        day.classList.add('to_selected');
                    }

                    if (document.getElementById('event_from').value && document.getElementById('event_to').value) {
                        let eventFromParts = document.getElementById('event_from').value.match(/(\d+)/g);
                        let eventToParts = document.getElementById('event_to').value.match(/(\d+)/g);
                        if (new Date( eventFromParts[2], eventFromParts[1]-1, eventFromParts[0]).getTime() > new Date( eventToParts[2], eventToParts[1]-1, eventToParts[0]).getTime()) {
                            document.getElementById('calendar-warning').style.display = "block";
                        } else {
                            document.querySelector('#event-datepicker form').submit();
                        }
                    }
                });
            }

            // If Today..
            if ((i + 1) == calendar.Today.getDate() && calendar.Selected.Month == calendar.Today.Month && calendar.Selected.Year == calendar.Today.Year) {
                day.className += " today";
            }
            days.appendChild(day);
        }
        // Next Month's Days
        let extraDays = 7;

        if (calendar.Selected.LastDay !== 0) {
            for (let i = 0; i < (extraDays - calendar.Selected.LastDay); i++) {
                let day = document.createElement('li');
                day.className += "cld-day nextMonth";
                //Disabled Days
                let d = (i + calendar.Selected.LastDay + 1) % 7;
                for (let q = 0; q < calendar.Options.DisabledDays.length; q++) {
                    if (d == calendar.Options.DisabledDays[q]) {
                        day.className += " disableDay";
                    }
                }

                let number = DayNumber(i + 1);
                day.appendChild(number);

                days.appendChild(day);
            }
        }
        mainSection.appendChild(days);
    }

    function GetEvents(eventFromDate, eventToDate) {
        require('axios').get('/ajax/events-activities', {
            params: {
                categories: calendar.Categories,
                fromDate: eventFromDate,
                toDate: eventToDate
            }
        }).then(function (response) {
            document.getElementsByClassName("events")[0].innerHTML = response.data;
        });
    }

    if (calendar.Options.Color) {
        mainSection.innerHTML += '<style>.cld-main{color:' + calendar.Options.Color + ';}</style>';
    }
    if (calendar.Options.LinkColor) {
        mainSection.innerHTML += '<style>.cld-title a{color:' + calendar.Options.LinkColor + ';}</style>';
    }
    element.appendChild(mainSection);

    if (calendar.Options.NavShow && calendar.Options.NavVertical) {
        AddSidebar();
    }
    if (calendar.Options.DateTimeShow) {
        AddDateTime();
    }
    AddLabels();
    AddDays();

    if (calendar.Options.eventsWithAjax && !jQuery.isEmptyObject(calendar.Categories)) {
        GetEvents(`1-${calendar.Selected.Month + 1}-${calendar.Selected.Year}`, `${calendar.Selected.Days}-${calendar.Selected.Month + 1}-${calendar.Selected.Year}`);
    }
}

function calendar(el, data, settings, categories) {
    let obj = new Calendar(data, settings, false, categories);
    createCalendar(obj, el);
}

export default calendar;
